export default {"src":"https://fishbrain.com/_next/static/media/bragIconFish.0d76f801.svg","height":51,"width":68,"blurWidth":0,"blurHeight":0};